module.exports = __webpack_public_path__ + "4eca2bcc7ac329e01b9c2a9263cea45c.svg";